// One-shot sound effects using Web Audio API

let ctx = null;

function getCtx() {
  if (!ctx) {
    ctx = new (window.AudioContext || window.webkitAudioContext)();
  }
  if (ctx.state === 'suspended') {
    ctx.resume();
  }
  return ctx;
}

/** Happy ascending chime for correct answers */
export function playCorrectSound() {
  try {
    const ac = getCtx();
    const now = ac.currentTime;
    const master = ac.createGain();
    master.gain.value = 0.8;
    master.connect(ac.destination);

    // Three-note ascending arpeggio: C5 → E5 → G5
    const notes = [523.25, 659.25, 783.99];
    notes.forEach((freq, i) => {
      const osc = ac.createOscillator();
      const gain = ac.createGain();
      osc.connect(gain);
      gain.connect(master);

      osc.type = 'sine';
      osc.frequency.value = freq;

      const t = now + i * 0.09;
      gain.gain.setValueAtTime(0, t);
      gain.gain.linearRampToValueAtTime(0.6, t + 0.03);
      gain.gain.exponentialRampToValueAtTime(0.001, t + 0.35);

      osc.start(t);
      osc.stop(t + 0.38);
    });

    // Sparkle shimmer on top
    const shimmer = ac.createOscillator();
    const sGain = ac.createGain();
    shimmer.connect(sGain);
    sGain.connect(master);
    shimmer.type = 'sine';
    shimmer.frequency.value = 1046.5; // C6
    const sTime = now + 0.25;
    sGain.gain.setValueAtTime(0, sTime);
    sGain.gain.linearRampToValueAtTime(0.3, sTime + 0.02);
    sGain.gain.exponentialRampToValueAtTime(0.001, sTime + 0.5);
    shimmer.start(sTime);
    shimmer.stop(sTime + 0.55);
  } catch (e) {
    console.warn('Audio playback failed (correct sound):', e);
  }
}

/** Soft descending buzzer for wrong answers */
export function playWrongSound() {
  try {
    const ac = getCtx();
    const now = ac.currentTime;
    const master = ac.createGain();
    master.gain.value = 0.6;
    master.connect(ac.destination);

    // Two low descending tones
    const osc1 = ac.createOscillator();
    const g1 = ac.createGain();
    osc1.connect(g1);
    g1.connect(master);
    osc1.type = 'triangle';
    osc1.frequency.setValueAtTime(220, now);
    osc1.frequency.linearRampToValueAtTime(160, now + 0.25);
    g1.gain.setValueAtTime(0.5, now);
    g1.gain.exponentialRampToValueAtTime(0.001, now + 0.3);
    osc1.start(now);
    osc1.stop(now + 0.35);

    const osc2 = ac.createOscillator();
    const g2 = ac.createGain();
    osc2.connect(g2);
    g2.connect(master);
    osc2.type = 'triangle';
    osc2.frequency.setValueAtTime(185, now + 0.15);
    osc2.frequency.linearRampToValueAtTime(130, now + 0.4);
    g2.gain.setValueAtTime(0.4, now + 0.15);
    g2.gain.exponentialRampToValueAtTime(0.001, now + 0.45);
    osc2.start(now + 0.15);
    osc2.stop(now + 0.5);
  } catch (e) {
    console.warn('Audio playback failed (wrong sound):', e);
  }
}

/** Soft pop sound for balloon selection */
export function playPopSound() {
  try {
    const ac = getCtx();
    const now = ac.currentTime;

    const osc = ac.createOscillator();
    const gain = ac.createGain();
    osc.connect(gain);
    gain.connect(ac.destination);

    osc.type = 'sine';
    osc.frequency.setValueAtTime(600, now);
    osc.frequency.exponentialRampToValueAtTime(200, now + 0.08);
    gain.gain.setValueAtTime(0.5, now);
    gain.gain.exponentialRampToValueAtTime(0.001, now + 0.1);
    osc.start(now);
    osc.stop(now + 0.12);
  } catch (e) {
    console.warn('Audio playback failed (pop sound):', e);
  }
}
